import { Injectable,Inject,PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LeafletService {
  public L:any;
  constructor(@Inject(PLATFORM_ID) private platformId: Object) { 
    if (isPlatformBrowser(platformId)) {
      this.L = require('leaflet');
    }
  }
}
